import PropTypes from 'prop-types'
import { useCallback, useEffect } from 'react'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import { useDispatch, useSelector } from 'react-redux'
import {
  addRestrictionIp,
  reset,
  setDescription,
  setIp,
} from 'features/restrictionIp/restrictionIpAddSlice'
import classNames from 'classnames'
import { fetchRestrictionIps } from 'features/restrictionIp/restrictionIpListSlice'
import TextInput from 'components/form/TextInput'
import { fail, failWithErrorResponse, success } from 'features/toast/Toast'
import useValidator from 'utils/hooks/useValidator'
import { isValidIp } from 'utils'

const RestrictionIpAdd = ({ handleClose }) => {
  const { ip, description, maxLength } = useSelector(
    state => state.restrictionIp.restrictionIpAdd
  )
  const dispatch = useDispatch()

  useEffect(() => () => dispatch(reset()), [dispatch])

  const { errors, validate } = useValidator(() => ({
    ip:
      (ip === '' && '광고노출제한 IP를 입력하세요.') ||
      (!isValidIp(ip) && '입력하신 IP가 올바르지 않습니다.'),
  }))

  const handleConfirm = useCallback(
    async ({ preventClose }) => {
      try {
        await validate()
      } catch (e) {
        fail(e.ip)
        preventClose()
        return
      }

      const { payload: addPayload, error: addError } = await dispatch(
        addRestrictionIp()
      )

      if (addError) {
        failWithErrorResponse(addPayload)
        preventClose()
      } else {
        success('IP가 정상 등록되었습니다.')
        dispatch(fetchRestrictionIps())
      }
    },
    [dispatch, validate]
  )

  return (
    <ConfirmModal
      title="광고노출 제한 IP 등록하기"
      handleClose={handleClose}
      onConfirm={handleConfirm}
      confirmText="저장">
      <table className="tbl_layer">
        <caption className="hide_caption">IP 입력 표</caption>
        <colgroup>
          <col width="161" />
          <col />
        </colgroup>
        <tbody>
          <tr className="tr_box">
            <th scope="row">광고노출 제한 IP</th>
            <td>
              <div className="inner_cell">
                <TextInput
                  id="inpTxt1"
                  placeholder="IP를 입력하세요."
                  value={ip}
                  onValueChange={v => dispatch(setIp(v))}
                  error={errors.ip}
                />
              </div>
            </td>
          </tr>
          <tr className="tr_box">
            <th scope="row">설명</th>
            <td>
              <div className="inner_cell">
                <div
                  className={classNames('box_textarea2 textarea_s', {
                    on: description,
                  })}>
                  <label htmlFor="tfArea" className="lab_txt">
                    설명을 입력하세요.
                  </label>
                  <textarea
                    name="tfArea"
                    id="tfArea"
                    className="tf_area"
                    value={description}
                    maxLength={maxLength}
                    onChange={e =>
                      dispatch(
                        setDescription(
                          e.target.value
                            .replace(/\n/g, '')
                            .substring(0, maxLength)
                        )
                      )
                    }></textarea>
                  <span className="num_byte">
                    <span className="screen_out">작성가능한 총 텍스트 수</span>
                    {maxLength - description.length}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ConfirmModal>
  )
}

export default RestrictionIpAdd

RestrictionIpAdd.propTypes = {
  handleClose: PropTypes.func.isRequired,
}
